export const AUTH_ISSUER = 'urn:hive:issuer';
export const AUTH_AUDIENCE = 'urn:hive:client';
